let url = "";
let pumpFrontendUrl = "";
let pwaUrl = "";
let adminUrl = "";
let isGalaxPayInProd = false;
let politicasPrivacidadeURL = "";
let termosUsoURL = "";
let logsVersoesURL = "";
let webPushPublicKey = "";

if (process.env.NODE_ENV === "development") {
  url = process.env.REACT_APP_BACKEND_URL;
  pumpFrontendUrl = process.env.REACT_APP_FRONTEND_PUMP_URL;
  pwaUrl = process.env.REACT_APP_FRONTEND_CLIENTE_URL;
  adminUrl = process.env.REACT_APP_FRONTEND_ADMIN_URL;
  politicasPrivacidadeURL = adminUrl + "/politica-de-privacidade";
  termosUsoURL = adminUrl + "/termos-de-uso";
  logsVersoesURL = adminUrl + "/versoes";
  webPushPublicKey = process.env.REACT_APP_WEB_PUSH_PUBLIC_KEY;
} else if (process.env.REACT_APP_STAGE === "homolog") {
  url = "https://dev.api.cashbarber.com.br";
  pumpFrontendUrl = "https://dev.pump.cashbarber.com.br";
  pwaUrl = "https://dev.cashbarber.com.br";
  adminUrl = "https://dev.admin.cashbarber.com.br";
  politicasPrivacidadeURL =
    "https://dev.painel.cashbarber.com.br/politica-de-privacidade";
  termosUsoURL = "https://dev.painel.cashbarber.com.br/termos-de-uso";
  logsVersoesURL = "https://dev.painel.cashbarber.com.br/versoes";
  webPushPublicKey =
    "BMf5GAN0LPUsaALujaqaM_i29Y0iPHlm3ncvgPYPdKJuielV2iU91qM-Iz0wuh8UXL7KV_jQYZyNzKvekuwpAsk";
} else {
  url = "https://api.cashbarber.com.br";
  pumpFrontendUrl = "https://pump.cashbarber.com.br";
  pwaUrl = "https://cashbarber.com.br";
  adminUrl = "https://admin.cashbarber.com.br";
  politicasPrivacidadeURL =
    "https://painel.cashbarber.com.br/politica-de-privacidade";
  termosUsoURL = "https://painel.cashbarber.com.br/termos-de-uso";
  logsVersoesURL = "https://painel.cashbarber.com.br/versoes";
  isGalaxPayInProd = true;
  webPushPublicKey =
    "BMf5GAN0LPUsaALujaqaM_i29Y0iPHlm3ncvgPYPdKJuielV2iU91qM-Iz0wuh8UXL7KV_jQYZyNzKvekuwpAsk";
}

export const Constants = {
  url: url,
  backendUrl: `${url}/api`,
  baseUrl: `${url}/api/painel`,
  pumpFrontendUrl,
  pwaUrl,
  adminUrl,
  isGalaxPayInProd,
  politicasPrivacidadeURL,
  termosUsoURL,
  logsVersoesURL,
  webPushPublicKey,
};
